// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseSlider_wrapper__NQ9BQ","isEmpty":"CourseSlider_isEmpty___RfR7","skeleton-loading":"CourseSlider_skeleton-loading__SbN4d"};